import { css, jsx } from '@emotion/core';
import { Icon, Spin } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import Heading from '@/src/shared/components/Heading';
import { colors, space } from '@/styles';

const { m } = space;
const spinner = <Icon type="loading" style={{ fontSize: 36 }} spin />;

const style = {
  container: css`
    border-radius: 2px;
    background-color: #ffffff;
    box-shadow: 0 6px 12px 0 rgba(35, 32, 32, 0.1);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
  `,
  text: css`
    color: ${colors.secondaryBlue};
  `,
  spinner: css`
    color: ${colors.secondaryBlue};
  `,
};

const LoadingResults = ({ text = 'Loading...', height }) => {
  return (
    <div css={style.container} style={{ height }}>
      <Spin indicator={spinner} css={[style.spinner, m.t24]} />
      <Heading type={4} tag={3} weight="bolder" css={[m.b24, m.t32, style.text]}>
        {text}
      </Heading>
    </div>
  );
};

LoadingResults.propTypes = {
  text: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

LoadingResults.defaultProps = {
  text: 'Loading...',
  height: 'auto',
};

export default LoadingResults;
